import { ProtectedJsonAPI } from '.'

export const Wallets = ProtectedJsonAPI.extend(
  '/wallets',
  {
    events: endpoint => endpoint.method('post').path(({id}) => `${id}/events`),
    show:   endpoint => endpoint.path(({id}) => id),
    addressPoolInit: endpoint => endpoint.method('post').path(({id}) => `${id}/address_pool_init`),
  }
)